import { Directive, Input, HostListener } from '@angular/core';
import { WindowService } from './window.service';

@Directive({
  selector: '[cmLinkGotoSection]',
})
export class LinkGotoSectionDirective {

  @Input() linkGotoSection: string;

  constructor(private win: WindowService) {}

  @HostListener('click')
  click() {
    const target = this.win.nativeDocument.querySelector(this.linkGotoSection);
    if (target) {
      this.win.nativeWindow.scrollTo(0, this.findPos(target));
    }
  }

  findPos(obj) {
    let curtop = 0;
    if (obj.offsetParent) {
      do {
        curtop += obj.offsetTop;
      } while (obj = obj.offsetParent);
    return curtop;
    }
  }
}
